import axios from "axios";
import { ActionTypes } from "utils/constants";
import { getEnvVar } from "utils/get-env-var";

export const fetchPricing = () => ({
    type: ActionTypes.FETCH_PRICING,
    payload: axios.get(`${getEnvVar('API_BASE')}/pricing`)
});
